import { apiGet, apiPost } from './api';

/**
 * TRTC 群聊（透传 xmarsLive /app/trtc/list 单条返回的字段）
 */
export interface TrtcGroup {
  id: number;
  groupId: string;
  groupName: string | null;
  ownerId: number | null;
  ownerName: string | null;
  groupType: number | null;
  introduction: string | null;
  notification: string | null;
  faceUrl: string | null;
  maxMemberCount: number | null;
  memberCount: number;
  applyJoinOption: string | null;
  muteAllMember: number | null;
  status: number | null;
  groupAttributes: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  thresholds: any[];
  isUserInGroup: boolean;
  hasPendingApplication: boolean;
}

export interface TrtcGroupListData {
  list: TrtcGroup[];
  totalCount: number;
  totalPage: number;
  currPage: number;
  pageSize: number;
}

/** 列表 */
export async function fetchTrtcGroups(params: {
  page?: number;
  limit?: number;
  employeeId?: number | null;
  groupName?: string;
  groupId?: string;
}): Promise<TrtcGroupListData> {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page ?? 1));
  qs.set('limit', String(params.limit ?? 12));
  if (params.employeeId != null) qs.set('employeeId', String(params.employeeId));
  if (params.groupName && params.groupName.trim()) qs.set('groupName', params.groupName.trim());
  if (params.groupId && params.groupId.trim()) qs.set('groupId', params.groupId.trim());

  const res = await apiGet<{ code: number; data: TrtcGroupListData; msg?: string }>(
    `/api/bot-trtc-group/list?${qs.toString()}`,
  );
  if (res.code !== 0) throw new Error(res.msg || '查询群聊列表失败');
  return res.data;
}

export interface ApplyJoinResult {
  /** xmarsLive 回包的 data 字段（success 中的 data；可能是状态码或文案） */
  data: any;
  botId: number;
  botUserId: number | null;
  botUserName: string | null;
}

/** 专属员工申请入群 */
export async function applyTrtcJoinGroup(body: {
  employeeId: number;
  groupId: string;
  reason?: string;
  inviterUserId?: number | null;
}): Promise<ApplyJoinResult> {
  const res = await apiPost<{ code: number; data: ApplyJoinResult; msg?: string }>(
    '/api/bot-trtc-group/apply',
    body,
  );
  if (res.code !== 0) throw new Error(res.msg || '申请加入群聊失败');
  return res.data;
}

export interface ApplyBatchItem {
  employeeId: number;
  success: boolean;
  botId?: number;
  botUserId?: number | null;
  botUserName?: string | null;
  data?: any;
  error?: string;
}

export interface ApplyBatchResult {
  results: ApplyBatchItem[];
  total: number;
  successCount: number;
  failedCount: number;
}

/** 多个专属员工批量申请同一群 */
export async function applyTrtcJoinGroupBatch(body: {
  employeeIds: number[];
  groupId: string;
  reason?: string;
  inviterUserId?: number | null;
}): Promise<ApplyBatchResult> {
  const res = await apiPost<{ code: number; data: ApplyBatchResult; msg?: string }>(
    '/api/bot-trtc-group/apply-batch',
    body,
  );
  if (res.code !== 0) throw new Error(res.msg || '批量申请加入群聊失败');
  return res.data;
}
